(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunday-club-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var info = document.querySelector('.sc-product-info');
    if (!info) return;
    var qtyCards = info.querySelectorAll('.sc-qty-card');
    var qtyLabel = info.querySelector('[data-sc-qty-label]');
    // Each price appears twice per option (card headline + button label), so
    // update every matching node rather than just the first.
    function setAll(selector, value) {
      if (value == null || value === '') return;
      info.querySelectorAll(selector).forEach(function (el) { el.textContent = value; });
    }

    // ----- Stain demo video -----
    // Plays itself when it reaches the viewport and pauses when it leaves, so
    // nothing downloads until someone actually scrolls to it. The file is a flat
    // 73MB MP4 with no adaptive streaming, so loading it on page load would cost
    // every visitor the lot.
    var vidWrap = document.querySelector('[data-sc-video]');
    if (vidWrap) {
      var vidEl = vidWrap.querySelector('[data-sc-video-el]');
      if (vidEl && 'IntersectionObserver' in window) {
        var vidStarted = false;
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              if (!vidStarted) { vidEl.preload = 'auto'; vidStarted = true; }
              var played = vidEl.play();
              // Autoplay can still be refused (data saver, low power mode).
              // The native controls remain, so the viewer can start it himself.
              if (played && played.catch) played.catch(function () {});
            } else if (!vidEl.paused) {
              vidEl.pause();
            }
          });
        }, { threshold: 0.4 }).observe(vidEl);
      }
    }

    qtyCards.forEach(function (card) {
      card.addEventListener('click', function () {
        qtyCards.forEach(function (c) {
          c.classList.remove('active');
          c.setAttribute('aria-checked', 'false');
        });
        card.classList.add('active');
        card.setAttribute('aria-checked', 'true');
        var nameEl = card.querySelector('.sc-qty-title');
        if (qtyLabel && nameEl) qtyLabel.textContent = nameEl.textContent.replace(/\s+/g, ' ').trim();
        // Subscribe option shows the discounted plan price; one-time shows full price.
        setAll('[data-sc-sub-price]', card.getAttribute('data-sub-price'));
        setAll('[data-sc-sub-perwash]', card.getAttribute('data-sub-per-wash'));
        setAll('[data-sc-onetime-price]', card.getAttribute('data-price'));
        setAll('[data-sc-onetime-perwash]', card.getAttribute('data-per-wash'));
        setAll('[data-sc-cadence]', card.getAttribute('data-cadence'));
        syncCtaLabels();
      });
    });


    // Each quantity card shows the price for whichever mode (subscribe /
    // one-time) is currently selected, so the cards and the buy button agree.
    // The CTA names the pack and shows its price, so the button alone tells you
    // what you are about to buy. Both buttons are updated: CSS shows whichever
    // matches the current mode.
    function syncCtaLabels() {
      var card = info.querySelector('.sc-qty-card.active') || qtyCards[0];
      if (!card) return;
      var pairs = [['subscribe', 'data-sub-cta', 'data-sub-price'], ['onetime', 'data-cta', 'data-price']];
      pairs.forEach(function (pair) {
        var btn = info.querySelector('[data-sc-option="' + pair[0] + '"] [data-sc-cta-label]');
        if (!btn) return;
        var label = card.getAttribute(pair[1]);
        var price = card.getAttribute(pair[2]);
        if (label) btn.textContent = label + ' \u2192';
      });
      syncSticky();
      syncSummary();
    }

    // ----- Bundle summary + Subscribe & Save switch -----
    var flex = info.querySelector('[data-sc-flex]');
    function put(sel, val) {
      var el = info.querySelector(sel);
      if (el && val != null && el.textContent !== val) el.textContent = val;
    }
    function syncSummary() {
      var card = info.querySelector('.sc-qty-card.active') || qtyCards[0];
      if (!card) return;
      var sub = info.getAttribute('data-sc-mode') === 'subscribe';
      var g = function (a) { return card.getAttribute(a) || ''; };
      var price = g(sub ? 'data-sub-price' : 'data-price');
      var was = g(sub ? 'data-sub-was' : 'data-was');
      var save = parseInt(g(sub ? 'data-sub-save' : 'data-save'), 10) || 0;
      var subSave = parseInt(g('data-sub-save'), 10) || 0;
      var cadence = g('data-cadence').replace(/^every /, '');
      put('[data-sc-sum-price]', price);
      put('[data-sc-sum-was]', was);
      put('[data-sc-sum-save]', save > 0 ? 'Save ' + save + '%' : '');
      put('[data-sc-sum-ship]', g(sub ? 'data-sub-ship' : 'data-ship'));
      var wasWrap = info.querySelector('[data-sc-sum-was-wrap]');
      if (wasWrap) wasWrap.hidden = !was;
      var saveEl = info.querySelector('[data-sc-sum-save]');
      if (saveEl) saveEl.hidden = save <= 0;
      put('[data-sc-flex-title]', sub ? (subSave > 0 ? 'Save ' + subSave + '% with Subscribe & Save' : 'Subscribe & Save') : 'One-time purchase');
      put('[data-sc-flex-sub]', sub ? 'Subscription \u00b7 skip, pause or cancel anytime' : 'A single delivery. No repeat orders.');
      put('[data-sc-flex-cad]', cadence);
      put('[data-sc-buy-note]', sub ? 'Refills: ' + price + ' every ' + cadence + '. Skip, pause or cancel anytime.' : 'One-time purchase. No repeat deliveries.');
      if (flex) flex.setAttribute('aria-checked', sub ? 'true' : 'false');
    }
    if (flex) {
      flex.addEventListener('click', function () {
        var mode = info.getAttribute('data-sc-mode') === 'subscribe' ? 'onetime' : 'subscribe';
        info.setAttribute('data-sc-mode', mode);
        syncCardPrices(mode);
        syncCtaLabels();
      });
    }

    function syncCardPrices(mode) {
      qtyCards.forEach(function (card) {
        var sub   = mode === 'subscribe';
        var price = card.getAttribute(sub ? 'data-sub-price' : 'data-price');
        var per   = card.getAttribute(sub ? 'data-sub-per-wash' : 'data-per-wash');
        var offer = card.getAttribute(sub ? 'data-sub-offer' : 'data-offer');
        var pEl = card.querySelector('[data-sc-card-price]');
        var wEl = card.querySelector('[data-sc-card-perwash]');
        var oEl = card.querySelector('[data-sc-card-offer]');
        var sEl = card.querySelector('[data-sc-card-was]');
        if (pEl && price) pEl.textContent = price;
        if (wEl && per) wEl.textContent = per;
        // Assigned even when empty: one-time has no offer on the single box, and
        // the label must clear rather than keep the subscribe wording.
        if (oEl) oEl.textContent = offer || '';
        // Only meaningful on subscribe: there is nothing to strike through
        // against the one-time price when one-time is what you are paying.
        if (sEl) sEl.textContent = card.getAttribute(sub ? 'data-sub-was' : 'data-was') || '';
      });
    }
    // ----- Sticky add to cart (phones and desktop) -----
    var sticky = info.querySelector('[data-sc-sticky]');
    var stickyBtn = sticky ? sticky.querySelector('[data-sc-sticky-btn]') : null;
    function syncSticky() {
      if (!sticky) return;
      var card = info.querySelector('.sc-qty-card.active') || qtyCards[0];
      if (!card) return;
      var sub = info.getAttribute('data-sc-mode') === 'subscribe';
      var price = card.getAttribute(sub ? 'data-sub-price' : 'data-price');
      var name = card.querySelector('.sc-qty-title');
      var priceEl = sticky.querySelector('[data-sc-sticky-price]');
      var selEl = sticky.querySelector('[data-sc-sticky-sel]');
      var sel = (name ? name.textContent.trim() : '') + ' \u00b7 ' + (sub ? 'Subscribe & Save' : 'One-time');
      // Only write when the text actually changes.
      if (priceEl && price && priceEl.textContent !== price) priceEl.textContent = price;
      if (selEl && selEl.textContent !== sel) selEl.textContent = sel;
    }
    function setStickyVisible(on) {
      sticky.classList.toggle('is-visible', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = on ? 0 : -1;
    }
    var buyBox = info.querySelector('.sc-buy-options');
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      // Visible only once the real buy buttons have scrolled off the TOP of
      // the screen. On a phone they start below the fold, and the bar should
      // not appear before the shopper has reached the real choices.
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        setStickyVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(buyBox);
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var real = Array.prototype.filter.call(info.querySelectorAll('[data-sc-buy]'), function (b) {
          return window.getComputedStyle(b).display !== 'none';
        })[0];
        if (!real || real.disabled) return;
        real.click();
        // Mirror the real button's busy state so it cannot be double-tapped.
        stickyBtn.disabled = true;
        var waited = 0;
        var poll = setInterval(function () {
          waited += 200;
          if (!real.disabled || waited > 10000) { clearInterval(poll); stickyBtn.disabled = false; }
        }, 200);
      });
    }

    // Sync everything to the mode the page loaded in (subscribe by default), so
    // the cards, prices and button agree before anything is clicked.
    syncCardPrices(info.getAttribute('data-sc-mode') || 'subscribe');
    syncCtaLabels();

    // Purchase-mode slider. The chosen segment sets data-sc-mode, which drives
    // the thumb position, which button shows, and the prices on every card.
    var buyChoices = info.querySelectorAll('[data-sc-choose]');
    buyChoices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        var mode = choice.getAttribute('data-sc-choose');
        info.setAttribute('data-sc-mode', mode);
        syncCardPrices(mode);
        syncCtaLabels();
        buyChoices.forEach(function (c) {
          var on = c === choice;
          c.classList.toggle('active', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });
    });



    // Buy buttons → Shopify cart add. Each qty card is a real Shopify variant
    // (1 Pack / 3 Pack / 5 Pack), quantity always 1. The "subscribe" button also
    // sends the variant's Appstle selling plan so checkout creates a subscription;
    // the "onetime" button deliberately omits it.
    info.querySelectorAll('[data-sc-buy]').forEach(function (ctaBtn) {
      ctaBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var mode = ctaBtn.getAttribute('data-sc-buy');
        var active = info.querySelector('.sc-qty-card.active') || qtyCards[0];
        var variantId = active ? active.getAttribute('data-variant-id') : info.getAttribute('data-sc-variant-id');
        var sellingPlanId = active ? active.getAttribute('data-selling-plan-id') : '';
        if (!variantId) {
          window.location.href = '/cart';
          return;
        }
        var originalText = ctaBtn.innerHTML;
        ctaBtn.disabled = true;
        ctaBtn.innerHTML = 'Adding…';
        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        if (mode === 'subscribe' && sellingPlanId) formData.append('selling_plan', sellingPlanId);
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed (' + res.status + ')');
            return res.json();
          })
          .then(function () {
            // Pull the updated cart, then hand off to the theme's slide-out drawer
            // instead of navigating away from the product page.
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (res) { return res.ok ? res.json() : null; })
              .then(function (cart) {
                ctaBtn.innerHTML = originalText;
                ctaBtn.disabled = false;

                var drawer = document.querySelector('cart-drawer-component');
                // No drawer on the page (cart set to "page" mode) — keep the old behaviour.
                if (!drawer) {
                  window.location.href = '/cart';
                  return;
                }

                // Theme-native event: refreshes drawer contents, cart bubble and
                // count, and auto-opens the drawer.
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart || undefined,
                    sourceId: 'sc-pdp-cta',
                    data: { source: 'sc-pdp-cta', itemCount: cart ? cart.item_count : undefined }
                  }
                }));

                // Covers the case where auto-open is switched off in theme settings.
                if (!drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') drawer.open();
              });
          })
          .catch(function (err) {
            console.error(err);
            ctaBtn.innerHTML = originalText;
            ctaBtn.disabled = false;
            alert('Sorry, we could not add that to your cart. Please try again, or refresh the page.');
          });
      });
    });


    // FAQ accordion — only one open at a time (top zone)
    var faqItems = document.querySelectorAll('.sc-faqs-top .sc-faq-item-top');
    faqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          faqItems.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        }
      });
    });

    // Top gallery — clicking a thumb swaps the main image
    var galleryMainImg = document.querySelector('[data-sc-gallery-main] img');
    var galleryThumbs = Array.prototype.slice.call(document.querySelectorAll('[data-sc-thumb]'));
    // Main image is tappable and swipeable, so the gallery can be cycled without
    // needing to hit a 60px thumbnail on a phone.
    var galleryMainWrap = document.querySelector('[data-sc-gallery-main]');
    if (galleryMainWrap && galleryThumbs.length > 1) {
      var touchX = null, touchY = null, moved = false;
      galleryMainWrap.addEventListener('click', function () {
        if (moved) { moved = false; return; }
        navigateGallery(1);
      });
      galleryMainWrap.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigateGallery(1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); navigateGallery(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); navigateGallery(-1); }
      });
      galleryMainWrap.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        touchX = t.clientX; touchY = t.clientY; moved = false;
      }, { passive: true });
      galleryMainWrap.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - touchX, dy = t.clientY - touchY;
        // Horizontal intent only, so a vertical page scroll never changes image.
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          moved = true;
          navigateGallery(dx < 0 ? 1 : -1);
        }
        touchX = null; touchY = null;
      }, { passive: true });
    }

    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        galleryThumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var fullSrc = thumb.getAttribute('data-full-src');
        if (galleryMainImg && fullSrc) {
          // The main image carries a srcset, which wins over src. Clear it on
          // swap or the browser keeps rendering the featured image.
          galleryMainImg.removeAttribute('srcset');
          galleryMainImg.removeAttribute('sizes');
          galleryMainImg.setAttribute('src', fullSrc);
          var thumbImg = thumb.querySelector('img');
          if (thumbImg && thumbImg.alt) galleryMainImg.setAttribute('alt', thumbImg.alt);
        }
      });
    });

    // Gallery arrows — prev/next swipe between images (wraps around)
    function getActiveThumbIndex() {
      for (var i = 0; i < galleryThumbs.length; i++) {
        if (galleryThumbs[i].classList.contains('active')) return i;
      }
      return 0;
    }
    function navigateGallery(direction) {
      if (galleryThumbs.length === 0) return;
      var current = getActiveThumbIndex();
      var next = (current + direction + galleryThumbs.length) % galleryThumbs.length;
      galleryThumbs[next].click();
    }
    // Arrow overlays removed for a cleaner gallery; left/right keys still move
    // between images when the thumbnail strip has focus.
    var thumbStrip = document.querySelector('.sc-gallery-thumbs');
    if (thumbStrip) {
      thumbStrip.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); navigateGallery(-1); }
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); navigateGallery(1); }
      });
    }

    // Member reviews — the row is a native scroller, so touch and trackpad
    // already work. These buttons exist for pointer users, who have nothing to
    // swipe and no other signal that the row continues past the edge.
    var motionOK = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ugcTrack = document.querySelector('[data-sc-ugc-track]');
    if (ugcTrack) {
      var ugcArrows = document.querySelectorAll('[data-sc-ugc-nav]');
      var ugcStep = function () {
        var card = ugcTrack.querySelector('.sc-ugc-card');
        // Measured rather than hard-coded: the card width is a clamp() and
        // changes with the viewport.
        return card ? card.getBoundingClientRect().width + 24 : 320;
      };
      var ugcSync = function () {
        var max = ugcTrack.scrollWidth - ugcTrack.clientWidth - 2;
        ugcArrows.forEach(function (btn) {
          btn.disabled = btn.getAttribute('data-sc-ugc-nav') === 'next'
            ? ugcTrack.scrollLeft >= max
            : ugcTrack.scrollLeft <= 2;
        });
      };
      ugcArrows.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-sc-ugc-nav') === 'next' ? 1 : -1;
          ugcTrack.scrollBy({ left: dir * ugcStep(), behavior: motionOK ? 'smooth' : 'auto' });
        });
      });
      ugcTrack.addEventListener('scroll', ugcSync, { passive: true });
      window.addEventListener('resize', ugcSync, { passive: true });
      ugcSync();
    }

    // How It Works — scroll progress bar
    var howTrack = document.querySelector('[data-sc-how-track]');
    var howBar = document.querySelector('[data-sc-how-progress]');
    if (howTrack && howBar) {
      var updateHowProgress = function () {
        var max = howTrack.scrollWidth - howTrack.clientWidth;
        if (max <= 0) { howBar.style.transform = 'translateX(0)'; return; }
        var progress = Math.max(0, Math.min(1, howTrack.scrollLeft / max));
        howBar.style.transform = 'translateX(' + (progress * 200) + '%)';
      };
      howTrack.addEventListener('scroll', updateHowProgress, { passive: true });
      window.addEventListener('resize', updateHowProgress);
      updateHowProgress();
    }


    // In-page links that point at a section. The href works on its own, so this
    // only softens the jump and moves focus to the destination, which a plain
    // anchor does not reliably do in every browser.
    document.querySelectorAll('[data-sc-scroll-to]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var target = document.querySelector(el.getAttribute('data-sc-scroll-to'));
        if (!target || !motionOK) return; // let the native jump happen
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });

    // Scroll-to-buy — for "Join the Club" links that should bring user back to the main buy box
    document.querySelectorAll('[data-sc-scroll-buy]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var hero = document.querySelector('.sc-pdp-hero');
        if (hero) hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Live social-proof number — gently fluctuates so it feels real
    var spCount = info.querySelector('[data-sc-sp-count]');
    if (spCount) {
      var current = parseInt(spCount.textContent, 10) || 19;
      var min = 14, max = 26;
      function tick() {
        var delta = Math.floor(Math.random() * 3) - 1; // -1, 0, +1
        current = Math.max(min, Math.min(max, current + delta));
        spCount.textContent = current;
        setTimeout(tick, 3000 + Math.random() * 4000);
      }
      setTimeout(tick, 2500);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
